import React from "react";
import { extractYouTubeId, ytThumb } from "../../lib/youtube";

const LABELS = {
  trailer_youtube_url: "Trailer · Link no YouTube (link 'Ver no YouTube' da seção)", cta_trailer: "Hero · Botão do trailer", trailer_label: "Trailer · Eyebrow da seção", trailer_title: "Trailer · Título da seção", nav_trailer: "Menu · Label Trailer", trailer_poster: "Trailer · Imagem de capa do player (URL, opcional; vazio = 1º frame do vídeo)", trailer_youtube_label: "Trailer · Texto do link YouTube",
  cast_eyebrow: "Elenco · Eyebrow", cast_title: "Elenco · Título (Enter quebra linha)", cast_body: "Elenco · Corpo", cast_soon_label: "Elenco · Rótulo card sem foto", cast_soon_hint: "Elenco · Subtexto card sem foto",
  premiere_date: "Estreia · Data/hora (formato 2026-09-22T20:00:00-03:00)", premiere_url: "Estreia · Link do lembrete (vídeo da estreia ou canal)",
  premiere_label: "Estreia · Rótulo do contador", premiere_date_text: "Estreia · Data por extenso",
  countdown_days: "Contador · 'dias'", countdown_hours: "Contador · 'horas'", countdown_min: "Contador · 'min'", countdown_sec: "Contador · 'seg'",
  countdown_live: "Contador · Texto quando já estreou",
  hero_video: "Trailer (link .mp4 hospedado — roda mudo no fundo do hero e com som no botão Assistir ao trailer; vazio = foto)",
  teaser_eyebrow: "Teaser na home · Eyebrow", teaser_title: "Teaser na home · Título (Enter quebra linha)", teaser_body: "Teaser na home · Corpo",
  teaser_cta: "Teaser na home · Botão", teaser_note: "Teaser na home · Nota sob o botão", nav_public_link: "Menu da home · Label do link Reality",
  nav_tag: "Menu · Tag ao lado do logo", nav_watch: "Menu · Link 'Episódios'", nav_cta: "Menu · Botão CTA", nav_back: "Menu · Link para o site do evento",
  pill1: "Hero · Pill 1", pill2: "Hero · Pill 2", pill3: "Hero · Pill 3",
  eyebrow: "Hero · Eyebrow", title1: "Hero · Título parte 1", title2: "Hero · Título destaque", title_sub: "Hero · Sufixo pequeno (ex: 'O reality')",
  headline: "Hero · Frase de impacto", subline_prefix: "Hero · Subline início", subline_accent: "Hero · Subline destaque",
  cta_primary: "Hero · Botão principal", cta_secondary: "Hero · Link secundário",
  meta_1_k: "Hero · Meta 1 label", meta_1_v: "Hero · Meta 1 valor", meta_1_s: "Hero · Meta 1 legenda",
  meta_2_k: "Hero · Meta 2 label", meta_2_v: "Hero · Meta 2 valor", meta_2_s: "Hero · Meta 2 legenda",
  meta_3_k: "Hero · Meta 3 label", meta_3_v: "Hero · Meta 3 valor", meta_3_s: "Hero · Meta 3 legenda",
  marquee: "Faixa rolante (separe frases com ·)",
  m_eyebrow: "Manifesto · Eyebrow", m_title: "Manifesto · Título (Enter quebra linha)", m_body: "Manifesto · Corpo",
  m_stat1_k: "Manifesto · Número 1", m_stat1_v: "Manifesto · Legenda 1",
  m_stat2_k: "Manifesto · Número 2", m_stat2_v: "Manifesto · Legenda 2",
  m_stat3_k: "Manifesto · Número 3", m_stat3_v: "Manifesto · Legenda 3",
  m_quote: "Manifesto · Citação", m_quote_by: "Manifesto · Autor da citação",
  ep_eyebrow: "Episódios · Eyebrow", ep_title: "Episódios · Título", ep_body: "Episódios · Corpo",
  ep_label: "Episódios · Palavra 'Episódio'", coming_soon_label: "Episódios · Selo 'Em breve'", coming_soon_hint: "Episódios · Dica sob 'Em breve'",
  watch_label: "Episódios · Texto 'Assistir agora'", channel_url: "Link do canal no YouTube", channel_label: "Texto do link do canal",
  p_eyebrow: "Casa Alta 02 · Eyebrow", p_title: "Casa Alta 02 · Título", p_body: "Casa Alta 02 · Corpo",
  p1_k: "Pilar 1 · Número", p1_t: "Pilar 1 · Título", p1_d: "Pilar 1 · Descrição",
  p2_k: "Pilar 2 · Número", p2_t: "Pilar 2 · Título", p2_d: "Pilar 2 · Descrição",
  p3_k: "Pilar 3 · Número", p3_t: "Pilar 3 · Título", p3_d: "Pilar 3 · Descrição",
  p_cta: "Casa Alta 02 · Botão",
  f_eyebrow: "Formulário · Eyebrow", f_title_pre: "Formulário · Título início", f_title_accent: "Formulário · Título destaque",
  f_body: "Formulário · Corpo", f_scarcity: "Formulário · Selo de escassez",
  f_name: "Campo · Nome", f_name_ph: "Campo · Nome (placeholder)",
  f_instagram: "Campo · Instagram", f_instagram_ph: "Campo · Instagram (placeholder)",
  f_whatsapp: "Campo · WhatsApp", f_whatsapp_ph: "Campo · WhatsApp (placeholder)",
  f_city: "Campo · Cidade", f_city_ph: "Campo · Cidade (placeholder)",
  f_followers: "Campo · Audiência", f_followers_opts: "Campo · Opções de audiência (separe com |)",
  f_why: "Campo · Por que você", f_why_ph: "Campo · Por que você (placeholder)",
  f_consent: "Formulário · Texto do consentimento", f_submit: "Formulário · Botão", f_submit_loading: "Formulário · Botão (enviando)",
  f_privacy: "Formulário · Nota de privacidade",
  s_eyebrow: "Sucesso · Eyebrow", s_title: "Sucesso · Título", s_body: "Sucesso · Corpo", s_cta: "Sucesso · Botão assistir", s_again: "Sucesso · Botão atualizar",
  c_line_pre: "Encerramento · Frase início", c_line_accent: "Encerramento · Frase destaque", c_cta: "Encerramento · Botão",
  footer_line: "Rodapé · Linha", footer_back: "Rodapé · Link para o site",
};

const LONG = /(_body|body$|_d$|desc|quote$|m_title|ep_title|p_title|cast_title|teaser_title|f_consent|marquee|hero_video)/;

function CastRow({ c, i, total, onChange, onMove, onRemove }) {
  const cls = "w-full border border-neutral-300 bg-white p-2.5 text-[13px] text-neutral-900 focus:outline-none focus:border-[color:var(--alta-red)]";
  return (
    <div className="border border-neutral-200 bg-neutral-50 p-4 grid grid-cols-1 md:grid-cols-[96px_1fr_auto] gap-4 items-start" data-testid={`cast-row-${i}`}>
      <div className="w-24 h-[120px] bg-neutral-200 overflow-hidden flex items-center justify-center mono text-[9px] text-neutral-500">
        {c.photo ? <img src={c.photo} alt="" className="w-full h-full object-cover" /> : "SEM FOTO"}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <label className="block"><span className="mono text-[9px] uppercase tracking-[0.24em] text-neutral-500">Nome</span>
          <input data-testid={`cast-name-${i}`} value={c.name || ""} onChange={(e) => onChange(i, { name: e.target.value })} className={`mt-1 ${cls}`} /></label>
        <label className="block"><span className="mono text-[9px] uppercase tracking-[0.24em] text-neutral-500">Instagram (@)</span>
          <input data-testid={`cast-handle-${i}`} value={c.handle || ""} onChange={(e) => onChange(i, { handle: e.target.value })} className={`mt-1 ${cls}`} placeholder="@perfil" /></label>
        <label className="block"><span className="mono text-[9px] uppercase tracking-[0.24em] text-neutral-500">Tag (se não tiver @)</span>
          <input data-testid={`cast-tag-${i}`} value={c.tag || ""} onChange={(e) => onChange(i, { tag: e.target.value })} className={`mt-1 ${cls}`} /></label>
        <label className="block md:col-span-3"><span className="mono text-[9px] uppercase tracking-[0.24em] text-neutral-500">Foto (URL · ideal 4:5). Vazio = card "Em breve"</span>
          <input data-testid={`cast-photo-${i}`} value={c.photo || ""} onChange={(e) => onChange(i, { photo: e.target.value })} className={`mt-1 ${cls}`} placeholder="https://..." /></label>
      </div>
      <div className="flex md:flex-col gap-2">
        <button type="button" onClick={() => onMove(i, -1)} disabled={i === 0} data-testid={`cast-up-${i}`} className="px-2 py-1 border border-neutral-300 text-[11px] disabled:opacity-30">↑</button>
        <button type="button" onClick={() => onMove(i, 1)} disabled={i === total - 1} data-testid={`cast-down-${i}`} className="px-2 py-1 border border-neutral-300 text-[11px] disabled:opacity-30">↓</button>
        <button type="button" onClick={() => onRemove(i)} data-testid={`cast-remove-${i}`} className="px-2 py-1 border border-red-300 text-red-700 text-[11px]">✕</button>
      </div>
    </div>
  );
}

function EpisodeRow({ ep, i, total, onChange, onMove, onRemove }) {
  const id = ep.youtube_id || "";
  return (
    <div className="border border-neutral-300 bg-white p-4 grid grid-cols-1 md:grid-cols-12 gap-4" data-testid={`ep-row-${i}`}>
      <div className="md:col-span-3">
        <div className="relative aspect-video bg-neutral-100 overflow-hidden">
          {id ? (
            <img src={ytThumb(id)} alt="" className="w-full h-full object-cover" />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center mono text-[9px] uppercase tracking-[0.28em] text-neutral-400 text-center px-3">
              Sem vídeo · aparece "Em breve"
            </div>
          )}
        </div>
        <div className="mt-2 flex items-center gap-1">
          <button type="button" onClick={() => onMove(i, -1)} disabled={i === 0} data-testid={`ep-up-${i}`} className="w-7 h-7 border border-neutral-300 text-neutral-600 disabled:opacity-30">↑</button>
          <button type="button" onClick={() => onMove(i, 1)} disabled={i === total - 1} data-testid={`ep-down-${i}`} className="w-7 h-7 border border-neutral-300 text-neutral-600 disabled:opacity-30">↓</button>
          <button type="button" onClick={() => onRemove(i)} data-testid={`ep-remove-${i}`} className="ml-auto mono text-[9px] uppercase tracking-[0.2em] text-red-600 border border-red-200 px-2 h-7 hover:bg-red-50">Remover</button>
        </div>
      </div>
      <div className="md:col-span-9 grid grid-cols-1 md:grid-cols-6 gap-3">
        <label className="md:col-span-1 block">
          <span className="mono text-[9px] uppercase tracking-[0.24em] text-neutral-500">Nº</span>
          <input value={ep.number || ""} onChange={(e) => onChange(i, { number: e.target.value })} data-testid={`ep-number-${i}`} className="mt-1 w-full border border-neutral-300 p-2 text-[13px] focus:outline-none focus:border-[color:var(--alta-red)]" />
        </label>
        <label className="md:col-span-3 block">
          <span className="mono text-[9px] uppercase tracking-[0.24em] text-neutral-500">Título</span>
          <input value={ep.title || ""} onChange={(e) => onChange(i, { title: e.target.value })} data-testid={`ep-title-${i}`} className="mt-1 w-full border border-neutral-300 p-2 text-[13px] focus:outline-none focus:border-[color:var(--alta-red)]" />
        </label>
        <label className="md:col-span-2 block">
          <span className="mono text-[9px] uppercase tracking-[0.24em] text-neutral-500">Duração (ex: 24 min)</span>
          <input value={ep.duration || ""} onChange={(e) => onChange(i, { duration: e.target.value })} data-testid={`ep-duration-${i}`} className="mt-1 w-full border border-neutral-300 p-2 text-[13px] focus:outline-none focus:border-[color:var(--alta-red)]" />
        </label>
        <label className="md:col-span-6 block">
          <span className="mono text-[9px] uppercase tracking-[0.24em] text-neutral-500">Link ou ID do YouTube (vazio = "Em breve")</span>
          <input
            value={id}
            onChange={(e) => onChange(i, { youtube_id: extractYouTubeId(e.target.value) || e.target.value.trim() })}
            onBlur={(e) => onChange(i, { youtube_id: extractYouTubeId(e.target.value) })}
            placeholder="https://youtu.be/XXXXXXXXXXX"
            data-testid={`ep-youtube-${i}`}
            className="mt-1 w-full border border-neutral-300 p-2 text-[13px] mono focus:outline-none focus:border-[color:var(--alta-red)]"
          />
        </label>
        <label className="md:col-span-6 block">
          <span className="mono text-[9px] uppercase tracking-[0.24em] text-neutral-500">Descrição provocativa</span>
          <textarea value={ep.desc || ""} onChange={(e) => onChange(i, { desc: e.target.value })} rows={2} data-testid={`ep-desc-${i}`} className="mt-1 w-full border border-neutral-300 p-2 text-[13px] leading-[1.5] focus:outline-none focus:border-[color:var(--alta-red)]" />
        </label>
      </div>
    </div>
  );
}

export default function RealityEditor({ values, onChange, onReplaceEpisodes, onReplaceCast }) {
  const episodes = Array.isArray(values.episodes) ? values.episodes : [];
  const cast = Array.isArray(values.cast) ? values.cast : [];
  const textKeys = Object.keys(values).filter((k) => k !== "episodes" && k !== "cast");

  const castUpdate = (i, patch) => onReplaceCast(cast.map((c, j) => (j === i ? { ...c, ...patch } : c)));
  const castMove = (i, d) => {
    const j = i + d;
    if (j < 0 || j >= cast.length) return;
    const next = [...cast];
    [next[i], next[j]] = [next[j], next[i]];
    onReplaceCast(next);
  };
  const castRemove = (i) => window.confirm(`Remover ${cast[i]?.name || "esta criadora"} do elenco?`) && onReplaceCast(cast.filter((_, j) => j !== i));
  const castAdd = () => onReplaceCast([...cast, { id: `c${Date.now()}`, name: "", handle: "", tag: "Criadora · Casa Alta", photo: "" }]);

  const update = (i, patch) => onReplaceEpisodes(episodes.map((e, j) => (j === i ? { ...e, ...patch } : e)));
  const move = (i, d) => {
    const j = i + d;
    if (j < 0 || j >= episodes.length) return;
    const next = [...episodes];
    [next[i], next[j]] = [next[j], next[i]];
    onReplaceEpisodes(next);
  };
  const remove = (i) => window.confirm(`Remover o episódio #${i + 1}?`) && onReplaceEpisodes(episodes.filter((_, j) => j !== i));
  const add = () =>
    onReplaceEpisodes([...episodes, { id: `e${Date.now()}`, number: String(episodes.length + 1).padStart(2, "0"), title: "Novo episódio", desc: "", youtube_id: "", duration: "" }]);

  return (
    <div className="p-6 border-t border-neutral-200 space-y-8" data-testid="reality-editor">
      <div className="border border-[color:var(--alta-red)]/30 bg-[color:var(--alta-red)]/5 p-4 text-[13px] text-neutral-700 leading-[1.6]">
        A página pública é a <span className="mono text-[color:var(--alta-red)]">home (/)</span>. Episódios sem link do YouTube aparecem como
        <em> "Em breve"</em> — cole o link quando publicar e clique em <em className="text-[color:var(--alta-red)]">Salvar e publicar</em>.
      </div>

      <div>
        <div className="flex items-center justify-between mb-4">
          <div className="mono text-[10px] uppercase tracking-[0.28em] text-[color:var(--alta-red)]">{episodes.length} episódios</div>
          <button type="button" onClick={add} data-testid="ep-add" className="btn-red-primary !text-[10px] !px-3 !py-2">+ Adicionar episódio</button>
        </div>
        <div className="space-y-3">
          {episodes.map((ep, i) => (
            <EpisodeRow key={ep.id || i} ep={ep} i={i} total={episodes.length} onChange={update} onMove={move} onRemove={remove} />
          ))}
        </div>
      </div>

      <div className="border-t border-neutral-200 pt-6">
        <div className="flex items-center justify-between mb-4">
          <div className="mono text-[10px] uppercase tracking-[0.28em] text-[color:var(--alta-red)]">Elenco · {cast.length} criadoras</div>
          <button type="button" onClick={castAdd} data-testid="cast-add" className="btn-red-primary !text-[10px] !px-3 !py-2">+ Adicionar criadora</button>
        </div>
        <div className="space-y-3">
          {cast.map((c, i) => (
            <CastRow key={c.id || i} c={c} i={i} total={cast.length} onChange={castUpdate} onMove={castMove} onRemove={castRemove} />
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 border-t border-neutral-200 pt-6">
        {textKeys.map((k) => {
          const long = LONG.test(k);
          const cls = "mt-2 w-full border border-neutral-300 bg-white p-3 text-[13px] text-neutral-900 focus:outline-none focus:border-[color:var(--alta-red)]";
          return (
            <label key={k} className={`block ${long ? "md:col-span-2" : ""}`}>
              <span className="mono text-[9px] uppercase tracking-[0.24em] text-neutral-500">{LABELS[k] || k}</span>
              {long ? (
                <textarea value={values[k] || ""} onChange={(e) => onChange(k, e.target.value)} rows={3} className={`${cls} leading-[1.55]`} />
              ) : (
                <input value={values[k] || ""} onChange={(e) => onChange(k, e.target.value)} className={cls} />
              )}
            </label>
          );
        })}
      </div>
    </div>
  );
}
